const Scroll = () => {
    return(
        <a href="#" data-target="html" className="scroll-to-target scroll-to-top"><i className="fa fa-angle-up"></i></a>
    )
}

export default Scroll;